import React from 'react'
import { Row, Col } from 'reactstrap'
import './Skeleton.scss'

function OrderListSkeleton() {
  return (
    <div className="order-list-skeleton">

      <Row className="skeleton-header list-event__item border-0 items-center p-3 m-0">
        <Col className="col-auto">
          <div className="skeleton-box skeleton-checkbox" />
        </Col>
        <Col className="col col-auto">
          <div className="skeleton-box skeleton-text" style={{ width: '100px' }} />
        </Col>
        <Col className="col col-auto">
          <div className="skeleton-box skeleton-text" style={{ width: '120px' }} />
        </Col>
        <Col className="col col-auto">
          <div className="skeleton-box skeleton-text" style={{ width: '150px' }} />
        </Col>
        <Col className="col col-auto">
          <div className="skeleton-box skeleton-text" style={{ width: '100px' }} />
        </Col>
        <Col className="col col-auto">
          <div className="skeleton-box skeleton-text" style={{ width: '120px' }} />
        </Col>
        <Col className="col col-auto text-center">
          <div className="skeleton-box skeleton-text mx-auto" style={{ width: '80px' }} />
        </Col>
        <Col className="col col-auto text-center">
          <div className="skeleton-box skeleton-text mx-auto" style={{ width: '100px' }} />
        </Col>
        <Col className="col col-auto text-center">
          <div className="skeleton-box skeleton-text mx-auto" style={{ width: '120px' }} />
        </Col>
        <Col className="col col-auto text-center">
          <div className="skeleton-box skeleton-text mx-auto" style={{ width: '140px' }} />
        </Col>
      </Row>

      {[1, 2, 3, 4, 5].map((index) => (
        <Row
          key={`skeleton-row-${index}`}
          className={`${index % 2 !== 0 ? 'bg-light' : ''} list-event__item border-0 items-center p-3 m-0`}
        >
          <Col className="col-auto">
            <div className="skeleton-box skeleton-checkbox" />
          </Col>
          <Col className="col col-auto">
            <div className="skeleton-box skeleton-text mb-1" style={{ width: '120px' }} />
            <div className="skeleton-box skeleton-text" style={{ width: '90px' }} />
          </Col>
          <Col className="col col-auto">
            <div className="skeleton-box skeleton-text" style={{ width: '100px' }} />
          </Col>
          <Col className="col col-auto">
            <div className="skeleton-box skeleton-text mb-1" style={{ width: '180px' }} />
            <div className="skeleton-box skeleton-text" style={{ width: '140px' }} />
          </Col>
          <Col className="col col-auto">
            <div className="skeleton-box skeleton-text" style={{ width: '100px' }} />
          </Col>
          <Col className="col col-auto">
            <div className="skeleton-box skeleton-text mb-1" style={{ width: '150px' }} />
            <div className="skeleton-box skeleton-text" style={{ width: '120px' }} />
          </Col>
          <Col className="col col-auto text-center">
            <div className="skeleton-box skeleton-text mx-auto" style={{ width: '70px' }} />
          </Col>
          <Col className="col col-auto text-center">
            <div className="skeleton-box skeleton-text mx-auto" style={{ width: '90px' }} />
          </Col>
          <Col className="col col-auto text-center">
            <div className="skeleton-box skeleton-icon mx-auto" />
          </Col>
          <Col className="col col-auto text-center">
            <div className="skeleton-box skeleton-select mx-auto" style={{ width: '160px' }} />
          </Col>
        </Row>
      ))}
    </div>
  )
}

export default OrderListSkeleton
